import React from 'react';
import {observer} from 'mobx-react';
import {withState} from 'shared/core';
import {auth} from 'main/tools';
import {Layout, Panel} from 'components';
import {CustomReportIndexState} from 'main/containers/reports/custom/list/state';
import MyReportsTable from './MyReportsTable';
import SharedReportsTable from './SharedReportsTable';

const CustomReportsIndexWithState = observer(({uiState}) => {
  return (
    <Layout>
      <Layout.Section secondary>
        <Panel.Stack loose>
          {auth.hasAccess('::CUSTOM_REPORT') && <MyReportsTable uiState={uiState}/>}
          <SharedReportsTable uiState={uiState}/>
        </Panel.Stack>
      </Layout.Section>
    </Layout>
  );
});

export default withState(CustomReportsIndexWithState, CustomReportIndexState);
